import React, { useState, useEffect } from "react";
import { AiFillEye } from "react-icons/ai";
import { motion } from "framer-motion";
import ReactTooltip from "react-tooltip";
import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import "./Work.scss";

const Work = () => {
  const [works, setWorks] = useState([]);
    const [filterWork, setFilterWork] = useState([]);
    const [activeFilter, setActiveFilter] = useState('Web');
    const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

    useEffect(() => {
        const query = '*[_type == "works"]';

        client.fetch(query).then((data) => {
            setWorks(data);
            // Filtra inicialmente los proyectos que están en In Progress y no están archivados
            setFilterWork(
                data.filter((work) => work.tags.includes('Web') && !work.tags.includes('Archived'))
            );
        });
    }, []);

    const handleWorkFilter = (item) => {
        setActiveFilter(item);
        setAnimateCard([{ y: 100, opacity: 0 }]);

        // Scroll al inicio de la sección work
        document.getElementById('work')?.scrollIntoView({ behavior: 'smooth' });

        setTimeout(() => {
            setAnimateCard([{ y: 0, opacity: 1 }]);
            setFilterWork(
                works.filter((work) =>
                    item === 'Archived'
                        ? work.tags.includes(item)
                        : (item === 'All' || work.tags.includes(item)) &&
                          !work.tags.includes('Archived')
                )
            );
        }, 500);
    };

  return (
    <>
      <h2 className="head-text">
        <br />
        My <span>Portfolio</span>
      </h2>

      <div className="app__work-filter">
        {[
                    'All',
                    'In Progress',
                    'Web',
                    'Mobile',
                    'Backend & APIs',
                    'Archived'
                ].map(
          (item, index) => (
            <div
              key={index}
              onClick={() => handleWorkFilter(item)}
              className={`app__work-filter-item app__flex p-text ${
                activeFilter === item ? "item-active" : ""
              }`}
            >
              {item}
            </div>
          )
        )}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <a href={work.projectLink} target="_blank" rel="noreferrer">
              <div className="app__work-img app__flex">
                <img src={urlFor(work.imgUrl)} alt={work.name} />

                <motion.div
                  whileHover={{ opacity: [0, 1] }}
                  transition={{
                    duration: 0.25,
                    ease: "easeInOut",
                    staggerChildren: 0.5,
                  }}
                  className="app__work-hover app__flex"
                >
                  {work.projectLink &&<a href={work.projectLink} target="_blank" rel="noreferrer">
                    <motion.div
                      whileInView={{ scale: [0, 1] }}
                      whileHover={{ scale: [1, 0.9] }}
                      transition={{ duration: 0.25 }}
                      className="app__flex"
                    >
                      <AiFillEye />
                    </motion.div>
                  </a>}
                </motion.div>
              </div>
            </a>
            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              <p 
                className="p-text" 
                style={{ 
                  marginTop: 10, 
                  display: '-webkit-box', 
                  WebkitLineClamp: 3, 
                  WebkitBoxOrient: 'vertical', 
                  overflow: 'hidden' 
                }}
                data-tip
                data-for={`work-${work.title}`}
              >
                {work.description}
              </p>
              <ReactTooltip
                id={`work-${work.title}`}
                effect="solid"
                arrowColor="#fff"
                className="skills-tooltip"
              >
                {work.description}
              </ReactTooltip>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "work",
  "app__primarybg"
);
